<script>
import Permissions from "../../../Mixins/Permissions";

export default {
    name: "AccidentReportTable",

    mixins: [Permissions],

    props: {
        reports: {
            type: Object,
            required: true,
        },
        page: {
            type: Number,
            required: true,
        },
    },

    watch: {
        page(page) {
            this.$emit("page-changed", page);
        },
    },

    methods: {
        clickRow(item) {
            this.$inertia.visit(this.route("accident-reports.show", item));
        },
        deleteReport(report) {
            if (!confirm(`Are you sure you want to delete this report?`)) {
                return;
            }

            this.$inertia.delete(
                this.route("accident-reports.destroy", report)
            );
        },
    },
};
</script>

<template>
    <div v-if="reports.data.length">
        <div class="d-flex mb-6">
            <v-pagination v-model="page" :length="reports.last_page" />
        </div>

        <div class="text-caption ml-3">
            Showing {{ reports.from }} to {{ reports.to }} of
            {{ reports.total }}
        </div>

        <v-simple-table class="row-pointer">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Reported By</th>
                    <th>Affected</th>
                    <th></th>
                </tr>
            </thead>

            <tbody>
                <tr
                    v-for="report in reports.data"
                    :key="report.id"
                    @click="clickRow(report)"
                >
                    <td>
                        {{ momentFormatDateTimeYear(report.accident_date) }}
                    </td>
                    <td>{{ report.creator.name }}</td>
                    <td>{{ report.affectee_name }}</td>
                    <td>
                        <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                    mdi-dots-vertical
                                </v-icon>
                            </template>

                            <v-list>
                                <inertia-link
                                    :href="
                                        route('accident-reports.show', report)
                                    "
                                    class="inertia-link"
                                >
                                    <v-list-item link>
                                        <v-list-item-title
                                            class="primary--text"
                                        >
                                            View
                                        </v-list-item-title>
                                    </v-list-item>
                                </inertia-link>
                                <template
                                    v-if="
                                        isSuperAdmin ||
                                        report.creator_id ===
                                            $page.props.auth.user.id
                                    "
                                >
                                    <v-divider />
                                    <v-list-item
                                        link
                                        @click="deleteReport(report)"
                                    >
                                        <v-list-item-title class="error--text">
                                            Delete
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>
                            </v-list>
                        </v-menu>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>

        <div class="d-flex mt-6">
            <v-pagination v-model="page" :length="reports.last_page" />
        </div>
    </div>

    <div v-else class="pa-6 text-center">
        <slot>No accident reports found</slot>
    </div>
</template>

<style scoped></style>
